import React from 'react';
import { Link } from 'react-router-dom';
import { DatabaseIcon, TrendingUpIcon, ZapIcon, TargetIcon, CheckCircleIcon, ActivityIcon, UsersIcon, BuildingIcon } from 'lucide-react';
export function DataSignalsPage() {
  return <div className="w-full bg-white" data-id="element-6656">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-cyan-900 via-blue-800 to-indigo-900 text-white py-24 overflow-hidden" data-id="element-6657">
        <div className="absolute inset-0 bg-grid-white/[0.05] bg-[size:20px_20px]" data-id="element-6658" />
        <div className="absolute inset-0" data-id="element-6659">
          <div className="absolute top-20 left-10 w-72 h-72 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" data-id="element-6660" />
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-6661" />
        </div>
        <div className="max-w-7xl mx-auto px-6 relative" data-id="element-6662">
          <div className="max-w-4xl mx-auto text-center" data-id="element-6663">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/20 rounded-full border border-cyan-400/30 mb-6" data-id="element-6664">
              <DatabaseIcon className="w-4 h-4" data-id="element-6665" />
              <span className="text-sm font-medium" data-id="element-6666">
                Real-Time GTM Intelligence
              </span>
            </div>
            <h1 className="text-6xl font-bold mb-6 leading-tight" data-id="element-6667">
              Data & Signals
            </h1>
            <p className="text-xl text-cyan-100 mb-8 leading-relaxed" data-id="element-6668">
              Access 250M+ contacts, real-time intent, technographics, and
              buying groups — all enriched automatically and ready to power your
              GTM plays.
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-6669">
              <Link to="/signup" className="px-8 py-4 bg-white text-cyan-900 rounded-lg hover:bg-cyan-50 font-medium text-lg shadow-lg hover:shadow-xl transition-all" data-id="element-6670">
                Explore Data
              </Link>
              <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-6671">
                Schedule Demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      {/* What Data & Signals Provides */}
      <section className="py-24 bg-white" data-id="element-6672">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6673">
          <div className="text-center mb-16" data-id="element-6674">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6675">
              What Data & Signals provides
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-6676">
              ZoomInfo data powers every play, segment, and recommendation in
              the platform. No external data sources needed.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-6677">
            <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-xl p-6 border-2 border-cyan-200" data-id="element-6678">
              <div className="w-14 h-14 bg-cyan-600 rounded-xl flex items-center justify-center mb-4" data-id="element-6679">
                <UsersIcon className="w-7 h-7 text-white" data-id="element-6680" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6681">
                250M+ contacts
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6682">
                Direct dials, emails, org charts, and job changes
              </p>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6 border-2 border-blue-200" data-id="element-6683">
              <div className="w-14 h-14 bg-blue-600 rounded-xl flex items-center justify-center mb-4" data-id="element-6684">
                <TrendingUpIcon className="w-7 h-7 text-white" data-id="element-6685" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6686">
                Intent signals
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6687">
                Real-time topic research and buying behavior
              </p>
            </div>
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-6 border-2 border-indigo-200" data-id="element-6688">
              <div className="w-14 h-14 bg-indigo-600 rounded-xl flex items-center justify-center mb-4" data-id="element-6689">
                <BuildingIcon className="w-7 h-7 text-white" data-id="element-6690" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6691">
                Firmographics
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6692">
                Revenue, employee count, industry, and growth trends
              </p>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6 border-2 border-purple-200" data-id="element-6693">
              <div className="w-14 h-14 bg-purple-600 rounded-xl flex items-center justify-center mb-4" data-id="element-6694">
                <ActivityIcon className="w-7 h-7 text-white" data-id="element-6695" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-6696">
                Technographics
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-6697">
                Tech stack, spend, and adoption patterns
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Key Data Types */}
      <section className="py-24 bg-gray-50" data-id="element-6698">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6699">
          <div className="text-center mb-16" data-id="element-6700">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6701">
              Data types that power GTM plays
            </h2>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-6702">
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6703">
              <div className="flex items-center gap-3 mb-4" data-id="element-6704">
                <div className="w-12 h-12 bg-cyan-600 rounded-lg flex items-center justify-center" data-id="element-6705">
                  <TrendingUpIcon className="w-6 h-6 text-white" data-id="element-6706" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6707">Intent data</h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6708">
                Track what topics accounts are researching across 10,000+ B2B
                sites. Score by recency, frequency, and topic relevance.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6709">
                <span className="px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm" data-id="element-6710">
                  10K+ sources
                </span>
                <span className="px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm" data-id="element-6711">
                  Real-time
                </span>
                <span className="px-3 py-1 bg-cyan-50 text-cyan-700 rounded-full text-sm" data-id="element-6712">
                  Topic scoring
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6713">
              <div className="flex items-center gap-3 mb-4" data-id="element-6714">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center" data-id="element-6715">
                  <UsersIcon className="w-6 h-6 text-white" data-id="element-6716" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6717">
                  Buying groups
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6718">
                Automatically detect and map buying committee members by role,
                influence, and engagement. No manual research.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6719">
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6720">
                  Auto-detection
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6721">
                  Role mapping
                </span>
                <span className="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-sm" data-id="element-6722">
                  Influence scoring
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6723">
              <div className="flex items-center gap-3 mb-4" data-id="element-6724">
                <div className="w-12 h-12 bg-indigo-600 rounded-lg flex items-center justify-center" data-id="element-6725">
                  <ActivityIcon className="w-6 h-6 text-white" data-id="element-6726" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6727">
                  Technographics
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6728">
                See what software accounts use, when contracts expire, and how
                much they spend. Perfect for competitive displacement.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6729">
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-6730">
                  Tech stack
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-6731">
                  Spend estimates
                </span>
                <span className="px-3 py-1 bg-indigo-50 text-indigo-700 rounded-full text-sm" data-id="element-6732">
                  Contract timing
                </span>
              </div>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-all" data-id="element-6733">
              <div className="flex items-center gap-3 mb-4" data-id="element-6734">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center" data-id="element-6735">
                  <BuildingIcon className="w-6 h-6 text-white" data-id="element-6736" />
                </div>
                <h3 className="text-xl font-bold text-gray-900" data-id="element-6737">
                  Firmographics
                </h3>
              </div>
              <p className="text-gray-700 mb-4" data-id="element-6738">
                Revenue, employee count, location, industry, and growth signals.
                Used for ICP scoring and segmentation.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-6739">
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6740">
                  Revenue data
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6741">
                  Growth signals
                </span>
                <span className="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-sm" data-id="element-6742">
                  ICP scoring
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* How It Powers GTM */}
      <section className="py-24 bg-white" data-id="element-6743">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6744">
          <div className="text-center mb-16" data-id="element-6745">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6746">
              How data powers your GTM
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6747">
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6748">
              <div className="flex items-start gap-4" data-id="element-6749">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6750" />
                <div data-id="element-6751">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6752">
                    Auto-enrichment
                  </h3>
                  <p className="text-gray-700" data-id="element-6753">
                    All accounts and contacts are enriched automatically. No
                    manual data entry or CSV uploads.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6754">
              <div className="flex items-start gap-4" data-id="element-6755">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6756" />
                <div data-id="element-6757">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6758">
                    Real-time updates
                  </h3>
                  <p className="text-gray-700" data-id="element-6759">
                    Intent, job changes, and tech stack updates flow in
                    continuously. Always current.
                  </p>
                </div>
              </div>
            </div>
            <div className="p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl border border-gray-200" data-id="element-6760">
              <div className="flex items-start gap-4" data-id="element-6761">
                <CheckCircleIcon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-6762" />
                <div data-id="element-6763">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-6764">
                    Play triggers
                  </h3>
                  <p className="text-gray-700" data-id="element-6765">
                    Signals automatically trigger plays. High intent detected?
                    Play launches instantly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Data Quality */}
      <section className="py-24 bg-gray-50" data-id="element-6766">
        <div className="max-w-7xl mx-auto px-6" data-id="element-6767">
          <div className="text-center mb-16" data-id="element-6768">
            <h2 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-6769">
              Why ZoomInfo data is different
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-6770">
            <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-6771">
              <div className="text-3xl font-bold text-cyan-600 mb-2" data-id="element-6772">95%</div>
              <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-6773">
                Accuracy rate
              </p>
              <p className="text-xs text-gray-600" data-id="element-6774">
                Verified through continuous validation
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-6775">
              <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-6776">250M+</div>
              <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-6777">
                Contact records
              </p>
              <p className="text-xs text-gray-600" data-id="element-6778">
                With direct dials and emails
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-6779">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-6780">
                35M+
              </div>
              <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-6781">
                Company profiles
              </p>
              <p className="text-xs text-gray-600" data-id="element-6782">
                Enriched with firmographics
              </p>
            </div>
            <div className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-6783">
              <div className="text-3xl font-bold text-purple-600 mb-2" data-id="element-6784">
                10K+
              </div>
              <p className="text-sm font-semibold text-gray-900 mb-1" data-id="element-6785">
                Intent sources
              </p>
              <p className="text-xs text-gray-600" data-id="element-6786">Real-time buying signals</p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-cyan-600 to-indigo-700 text-white" data-id="element-6787">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-6788">
          <h2 className="text-4xl font-bold mb-6" data-id="element-6789">
            Ready to power your GTM with real data?
          </h2>
          <p className="text-xl text-cyan-100 mb-8" data-id="element-6790">
            Access ZoomInfo's complete data platform
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-6791">
            <Link to="/signup" className="px-8 py-4 bg-white text-cyan-600 rounded-lg hover:bg-cyan-50 font-medium text-lg shadow-lg" data-id="element-6792">
              Explore Data
            </Link>
            <Link to="/website/contact" className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white/10 font-medium text-lg" data-id="element-6793">
              Talk to Sales
            </Link>
          </div>
        </div>
      </section>
    </div>;
}